<template>
  <GridAuto minWidth="20rem">
    <Card v-if="orgInsights.learningCenter.visible">
      <HeadingSmall>
        Learning Center
      </HeadingSmall>
      <ul
        :class="$style.linkList"
        data-test-id="HomeSupportSection__linkList"
      >
        <li
          v-for="(link, index) in homeSupportSectionUrls.resourceLinks"
          :key="index"
        >
          <ButtonLink
            :class="$style.link"
            :data-test-id="`HomeSupportSection__${homeSupportSectionUrls.name}`"
            :isMatchText="false"
            :text="link.text"
            @click="handleEventTracking(
              link.text,
              link.url
            )"
          />
        </li>
      </ul>
    </Card>
    <Card v-if="orgInsights.jcUniversity.visible">
      <HeadingSmall>
        JumpCloud University
      </HeadingSmall>
      <ParagraphBody>
        We are happy to announce our new education center to help support IT Admins.
      </ParagraphBody>
      <div
        :class="$style.jcuLinkContainer"
        data-test-id="HomeSupportSection__jcuLinkContainer"
      >
        <ButtonLink
          :class="$style.link"
          :isMatchText="false"
          :text="homeSupportSectionUrls.jcuLink.text"
          @click="handleEventTracking(
            homeSupportSectionUrls.jcuLink.text,
            homeSupportSectionUrls.jcuLink.url
          )"
        />
      </div>
    </Card>
    <Card v-if="orgInsights.officeHours.visible">
      <HeadingSmall>
        JumpCloud Office Hours
      </HeadingSmall>
      <ParagraphBody>
        Join a live Q&A session for IT admins to connect with
        each other and JumpCloud technical experts.
      </ParagraphBody>
      <div
        :class="$style.officeHoursLinkContainer"
        data-test-id="HomeSupportSection__officeHoursLinkContainer"
      >
        <ButtonLink
          :class="$style.link"
          :isMatchText="false"
          :text="homeSupportSectionUrls.officeHoursLink.text"
          @click="handleEventTracking(
            homeSupportSectionUrls.officeHoursLink.text,
            homeSupportSectionUrls.officeHoursLink.url
          )"
        />
      </div>
    </Card>
  </GridAuto>
</template>

<script>
import {
  ButtonLink,
  Card,
  GridAuto,
  HeadingSmall,
  ParagraphBody,
} from '@jumpcloud/ui-components';
import {
  ItemTypeConsts, StoreModuleMap,
} from 'client/util/Constants';
import { eventLocations, eventProperties } from 'client/GrowthEngineering/utilities/GrowthConstants';
import { mapState } from 'vuex';
import EventHelper from 'client/GrowthEngineering/EventHelper';
import HomeWidgetConsts from 'client/HomePageV2/constants/HomeWidgetConsts';
import SegmentEventMixin from 'client/HomePageV2/mixins/SegmentEventMixin';

const {
  description,
  location,
  section,
  toUrl,
  text: textEventProp,
} = eventProperties;

const {
  homePage,
} = eventLocations;
const userDisplayPreferencesModule = StoreModuleMap[ItemTypeConsts.userDisplayPreferences];
const { homeSupportSectionUrls } = HomeWidgetConsts;

export default {
  name: 'HomeSupportSection',

  components: {
    ButtonLink,
    Card,
    GridAuto,
    HeadingSmall,
    ParagraphBody,
  },

  mixins: [SegmentEventMixin],

  data: () => ({
    homeSupportSectionUrls,
    location: homePage,
  }),

  computed: {
    // Admin Level widget setting
    ...mapState(userDisplayPreferencesModule, {
      displaySettings: state => state.displayPreferencesData,
    }),

    orgInsights() {
      return this.displaySettings.display;
    },

  },

  methods: {
    handleEventTracking(text, url) {
      EventHelper.triggerLinkClicked({
        [description]: 'Home support metric link',
        [location]: this.location,
        [section]: 'Home support section',
        [toUrl]: url,
        [textEventProp]: text,
      });
      window.open(url, '_blank');
    },
  },
};
</script>

<style module scoped>
.linkList {
  list-style-type: none;
  padding-left: 0;
}

.linkList li { padding-bottom: var(--jc-spacer-medium); }

.jcuLinkContainer,
.officeHoursLinkContainer { margin-top: var(--jc-spacer); }
</style>
